import React from 'react';

const Spinner: React.FC = () => {
  return (
    <>
      <style>{`
        @keyframes bigBounce {
          0%, 20%, 53%, 80%, 100% {
            transform: translateY(0);
          }
          40%, 43% {
            transform: translateY(-10px);
          }
          70% {
            transform: translateY(-5px);
          }
          90% {
            transform: translateY(-2px);
          }
        }
        .big-bounce {
          animation: bigBounce 1s ease-in-out infinite;
        }
      `}</style>
      <div className="flex items-center justify-center space-x-1">
        {/* 3つのキューブによる大きな動きのローディング */}
        <div 
          className="w-2 h-2 bg-brand-primary big-bounce"
          style={{ 
            animationDelay: '0ms'
          }}
        ></div>
        <div 
          className="w-2 h-2 bg-brand-primary big-bounce"
          style={{ 
            animationDelay: '0.1s'
          }}
        ></div>
        <div 
          className="w-2 h-2 bg-brand-primary big-bounce"
          style={{ 
            animationDelay: '0.2s'
          }}
        ></div>
      </div>
    </>
  );
};

export default Spinner;